<!-- @veltra/icons generated sha256:060a9fb4049065ce gen:8 source:src/svg/normal/form-table.svg -->
<script setup lang="ts">
defineOptions({ name: 'FormTable' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <rect
      width="14"
      height="14"
      x="1"
      y="1"
      fill="none"
      stroke="currentColor"
      stroke-width="1.2"
      rx="2"
    />
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-width="1.2"
      d="M1 5h14M1 10h14M5 1v14"
    />
  </svg>
</template>
